import {Directive, Input, NgModule} from '@angular/core';

const HOST =
  'sd-btn inline-flex items-center justify-center gap-1.5 rounded-lg text-sm font-medium transition disabled:opacity-50 disabled:pointer-events-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--m365-accent,#111)]';

@Directive({
  selector: 'button[sd-btn], a[sd-btn], button[sdButton], a[sdButton]',
  standalone: true,
  host: {class: `${HOST} sd-btn--text px-3 py-2 text-[var(--m365-text-primary,#111)] hover:bg-black/[0.04]`},
})
export class SdButton {
  @Input() color: 'primary' | 'accent' | 'warn' | string | undefined;
}

@Directive({
  selector: 'button[sd-btn-raised], a[sd-btn-raised]',
  standalone: true,
  host: {
    class: `${HOST} sd-btn--raised px-3.5 py-2 bg-white border border-[var(--m365-border-rest,#ececf0)] shadow-sm hover:bg-black/[0.03]`,
  },
})
export class SdRaisedButton {
  @Input() color: string | undefined;
}

@Directive({
  selector: 'button[sd-btn-flat], a[sd-btn-flat]',
  standalone: true,
  host: {
    class: `${HOST} sd-btn--flat px-3.5 py-2 bg-[var(--m365-accent,#111)] text-white hover:bg-[var(--m365-accent-hover,#000)]`,
    '[class.bg-red-600]': 'color === "warn"',
    '[class.bg-[var(--m365-accent,#111)]]': 'color !== "warn"',
  },
})
export class SdFlatButton {
  @Input() color: string | undefined;
}

@Directive({
  selector: 'button[sd-btn-stroked], a[sd-btn-stroked]',
  standalone: true,
  host: {
    class: `${HOST} sd-btn--stroked px-3.5 py-2 border border-[var(--m365-border-strong,#d8d8de)] bg-white hover:bg-black/[0.03]`,
  },
})
export class SdStrokedButton {
  @Input() color: string | undefined;
}

@Directive({
  selector: 'button[sd-btn-icon], a[sd-btn-icon], button[sdIconButton], a[sdIconButton]',
  standalone: true,
  host: {class: `${HOST} sd-btn--icon h-9 w-9 rounded-full p-0 hover:bg-black/[0.06]`},
})
export class SdIconButton {
  @Input() color: string | undefined;
}

@Directive({
  selector: 'button[sd-btn-fab], a[sd-btn-fab], button[sd-btn-fab], a[sd-btn-fab]',
  standalone: true,
  host: {
    class: `${HOST} sd-btn--fab h-9 w-9 rounded-full p-0 bg-[var(--m365-bg-subtle,#f4f4f7)] text-[var(--m365-text-secondary,#6b6b70)] hover:bg-black/[0.08]`,
  },
})
export class SdMiniFabButton {
  @Input() color: string | undefined;
}

@NgModule({
  imports: [SdButton, SdRaisedButton, SdFlatButton, SdStrokedButton, SdIconButton, SdMiniFabButton],
  exports: [SdButton, SdRaisedButton, SdFlatButton, SdStrokedButton, SdIconButton, SdMiniFabButton],
})
export class SdButtonModule {}
